import type {ModalOverlayProps} from 'react-aria-components'
import * as Styled from './modal.styled'
import type {ReactNode} from 'react'

interface ModalStyleProps {
    size?: 'sm' | 'md' | 'lg' | 'xl'
}

interface Props extends Omit<ModalOverlayProps, 'children'>, ModalStyleProps {
    label: string
    children: ReactNode
    onClose?: () => void
}

export function Modal(props: Props) {
    const {children, label, onClose, size, ...restOfProps} = props

    return (
        <Styled.ModalOverlay
            {...restOfProps}
            onOpenChange={(open) => {
                if (!open && onClose) {
                    onClose()
                }
            }}
        >
            <Styled.Modal size={size}>
                <Styled.Dialog aria-label={label}>{children}</Styled.Dialog>
            </Styled.Modal>
        </Styled.ModalOverlay>
    )
}
